import { Buffer } from "buffer";
import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import * as serviceworker from './serviceWorker';
import App from "./App";

window.Buffer = Buffer;

// ── Mobile viewport fix (Safari address bar + teclado virtual) ────────
// Safari mobile não respeita 100vh corretamente — a barra de endereço muda o tamanho.
// Além disso, 100dvh NÃO encolhe quando o teclado virtual abre no iOS/Android.
// Usamos visualViewport API (quando disponível) para altura real visível.
const setVh = () => {
  const vh = window.visualViewport
    ? window.visualViewport.height * 0.01
    : window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  // --app-height: altura exata do viewport visual (para containers raiz)
  const appHeight = window.visualViewport
    ? `${window.visualViewport.height}px`
    : `${window.innerHeight}px`;
  document.documentElement.style.setProperty('--app-height', appHeight);
};
setVh();
window.addEventListener('resize', setVh);
// Orientação também pode mudar o tamanho
window.addEventListener('orientationchange', () => setTimeout(setVh, 100));
// visualViewport.resize dispara quando o teclado virtual abre/fecha
if (window.visualViewport) {
  window.visualViewport.addEventListener('resize', setVh);
  window.visualViewport.addEventListener('scroll', setVh);
}

// Suprimir overlay de erro benigno do ResizeObserver (comum no Recharts e Material-UI durante animações de layout)
window.addEventListener('error', (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.' || e.message === 'ResizeObserver loop limit exceeded') {
    e.stopImmediatePropagation();
  }
});

ReactDOM.render(
	<CssBaseline>
		<App />
	</CssBaseline>,
	document.getElementById("root"),
	() => {
		window.finishProgress();
	}
);

// Ativado para permitir PWA (Botão Instalar App) mesmo em desenvolvimento
serviceworker.register();
